module.exports = __webpack_public_path__ + "static/media/Food Processing Entreprise (CMN) - Desktop - 22-11-2024 C.0abf6f8d.gif";